/** @jsxImportSource @emotion/react */
import { useEffect } from 'react';
import {
    hooks as commonHooks,
    types as commonTypes,
    analytics as commonAnalytics,
} from '@sitebuilder/common';

interface DynamicEvent {
    eventName: string;
    analyticItems: AnalyticsItem[];
}

interface AnalyticsItem {
    name: string;
    value: string;
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    dynamicEvents?: DynamicEvent[];
}

const AnalyticsOnLoad = (props: commonTypes.WidgetInstanceProps) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const appContext = commonHooks.useAppContext();
    const { inEditMode } = appContext;
    const { data } = props;
    const { dynamicEvents } = widgetProperties || props;

    const analytics = commonAnalytics.useAnalyticsTracking();
    const i18n = commonHooks.useLocalization();

    // send track on load
    useEffect(() => {
        const updatedDynamicEvents: DynamicEvent[] = [];
        if (typeof dynamicEvents === 'object' && dynamicEvents !== null) {
            dynamicEvents.forEach((event) => {
                const analyticItems = event?.analyticItems;
                if (analyticItems && analyticItems.length > 0) {
                    const updatedAnalyticItems = analyticItems.map((item: AnalyticsItem) => {
                        return {
                            ...item,
                            value: i18n.format(item.value, data),
                        };
                    });

                    // Return a new dynamicEvent object with updated analyticItems
                    updatedDynamicEvents.push({
                        ...event,
                        analyticItems: updatedAnalyticItems,
                    });
                }
            });
        }

        const trackingData = {
            dynamicEvents: updatedDynamicEvents,
        };

        // only track if dynamicEvents are available
        if (updatedDynamicEvents.length > 0) {
            analytics.track(trackingData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {inEditMode && (
                <div>
                    <div data-testid="analytics-on-load">
                        <p>Anlaytics on Load</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default AnalyticsOnLoad;
